import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminParceiro: Routes = [
  {
    path: 'fabricantes',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'PAR_FABRICANTE',
      preload: false,
      breadcrumb: { label: 'Fabricantes', icon: 'mdi mdi-office-building' }
    },
    loadChildren: () =>
      import('@modules/fabricantes/fabricantes.module').then(
        m => m.FabricantesModule
      )
  },
  {
    path: 'fornecedores',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'PAR_FORNECEDOR',
      preload: false,
      breadcrumb: { label: 'Fornecedores', icon: 'mdi mdi-domain' }
    },
    loadChildren: () =>
      import('@modules/fornecedor/fornecedor.module').then(
        m => m.FornecedorModule
      )
  },
  {
    path: 'cliente',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'PAR_CLIENTE',
      preload: false,
      breadcrumb: { label: 'Clientes', icon: 'mdi mdi-account' }
    },
    loadChildren: () =>
      import('@app/modules/clientes/clientes.module').then(m => m.ClienteModule)
  },
  {
    path: 'precliente',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PAR_PRE_CLIENTE',
      breadcrumb: {
        label: 'Pré clientes',
        icon: 'mdi mdi-contacts-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/precliente/precliente.module').then(
        m => m.PreClienteModule
      )
  },
  {
    path: 'vendedor',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PAR_VENDEDOR',
      breadcrumb: {
        label: 'Vendedores',
        icon: 'mdi mdi-account-multiple-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/vendedor/vendedor.module').then(
        m => m.VendedorModule
      )
  },
  {
    path: 'supervisor',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PAR_SUPERVISOR',
      breadcrumb: {
        label: 'Supervisores',
        icon: 'mdi mdi-account-supervisor-circle-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/supervisor/supervisor.module').then(
        m => m.SupervisorModule
      )
  }
];
